import {
  PANEL_TOGGLE_TITLE_VARIANT_S,
  PanelToggle
} from 'mailup-web-components'
import { campaignState } from 'Pages/Campaign/recoil/state/campaign'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

const PanelActivate = () => {
  const intl = useIntl()

  const [{ Enabled }, setEnabled] = useRecoilState(campaignState)

  const onClick = () => {
    setEnabled((prev) => ({ ...prev, Enabled: !prev.Enabled, isDirty: true }))
  }

  return (
    <PanelToggle
      title={intl.formatMessage({
        id: 'Load.ContentsCampaignWizard.AttivaCampagna'
      })}
      titleVariant={PANEL_TOGGLE_TITLE_VARIANT_S}
      checked={Enabled}
      onChange={onClick}
    />
  )
}

export default PanelActivate
